'use strict';
import * as $i_otpauth from "otpauth";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_totp_Otp$() {
}
export { $c_Lpresto_ui_totp_Otp$ as $c_Lpresto_ui_totp_Otp$ };
$p = $c_Lpresto_ui_totp_Otp$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_totp_Otp$;
/** @constructor */
function $h_Lpresto_ui_totp_Otp$() {
}
export { $h_Lpresto_ui_totp_Otp$ as $h_Lpresto_ui_totp_Otp$ };
$h_Lpresto_ui_totp_Otp$.prototype = $p;
$p.ac2 = (function(seed) {
  try {
    var cfg = (() => {
      var seed$2 = null;
      seed$2 = seed;
      var this$2 = ({});
      this$2.secret = null;
      this$2.algorithm = null;
      this$2.digits = null;
      this$2.period = null;
      this$2.secret = $i_otpauth.Secret.fromBase32(seed$2);
      this$2.algorithm = (void 0);
      this$2.digits = (void 0);
      this$2.period = (void 0);
      return this$2;
    })();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(new $i_otpauth.TOTP(cfg).generate());
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.cOI = (function() {
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_RTLong$();
  var value = ((+Date.now()) / 1000.0);
  var lo = this$1.nW(value);
  var hi = this$1.af;
  var this$2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_RTLong$();
  return ((30 - this$2.bO(lo, hi, 30, 0)) | 0);
});
var $d_Lpresto_ui_totp_Otp$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_totp_Otp$, "presto.ui.totp.Otp$", ({
  a4l: 1
}));
export { $d_Lpresto_ui_totp_Otp$ as $d_Lpresto_ui_totp_Otp$ };
var $n_Lpresto_ui_totp_Otp$;
function $m_Lpresto_ui_totp_Otp$() {
  if ((!$n_Lpresto_ui_totp_Otp$)) {
    $n_Lpresto_ui_totp_Otp$ = new $c_Lpresto_ui_totp_Otp$();
  }
  return $n_Lpresto_ui_totp_Otp$;
}
export { $m_Lpresto_ui_totp_Otp$ as $m_Lpresto_ui_totp_Otp$ };
//# sourceMappingURL=presto.ui.totp.-Otp$.js.map
